import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import { GlobalContext } from '../../../App'
import PrimeTable from '../../../components/PrimeTable'

const AtendimentoExterno = () => {
  const { usuarioLogado } = useContext(GlobalContext)

  const [refresh, setRefresh] = useState(0)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
    setRefresh((v) => !v)
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar])

  return (
    <Programa codigo="CtrlAtendimentoExterno" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              action="lista"
              codigo="CtrlAtendimentoExterno"
              refresh={refresh}
              habSearch
              parametros={{ idUsuario: usuarioLogado.id }}
              collumnsDateHour={[3, 4]}
              collumnsCurrency={[5, 6]}
              head={[
                'Atendimento',
                'Paciente',
                'Local',
                'Início',
                'Fim',
                'Atendido',
                'Pago',
              ]}
              line={(item) => [
                item[0],
                item[1]?.[1] || '',
                item[2],
                item[4],
                item[5],
                item[6] || 0.0,
                item[7] || 0.0,
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, idUsuario: usuarioLogado.id }} />
      )}
    </Programa>
  )
}

export default AtendimentoExterno
